<input nbInput fullWidth placeholder="Suchen" [value]="model.searchTerm()" (input)="model.updateSearchTerm($event)">

<cdk-tree #tree
          [dataSource]="rootNodes()"
          [treeControl]="treeControl"

>
  <cdk-nested-tree-node *cdkTreeNodeDef="let node; let level = level" cdkTreeNodePadding>
    <ng-container *ngIf="model.isVisible(node)">
      <div class="node-body" [style.padding-left]="getNodePadding(level)" (click)="onNodeClicked(node, $event)">
        <div class="expand-toggle" [class.expanded]="treeControl.isExpanded(node)">
          <button *ngIf="node.children?.length" cdkTreeNodeToggle [cdkTreeNodeToggleRecursive]="true" (click)="$event.stopPropagation()">
            <nb-icon icon="chevron-right-outline" pack="eva"></nb-icon>
          </button>
        </div>
        <nb-checkbox
          [ngModel]="model.isSelected(node)"
          [indeterminate]="model.isIndeterminate(node)"
          (ngModelChange)="model.setSelected(node, $event)"
          [disabled]="disabled() || model.isDisabled(node)"
          (click)="onCheckboxClick(node, $event)"
        ></nb-checkbox>
        <ng-container *ngIf="node.icon">
          <wr-privilege-icon [privilege]="node.icon"></wr-privilege-icon>
        </ng-container>
        {{ node.name }}
      </div>

      <div *ngIf="treeControl.isExpanded(node)" class="node-children">
        <ng-container cdkTreeNodeOutlet></ng-container>
      </div>
    </ng-container>
  </cdk-nested-tree-node>
</cdk-tree>
